import { Expose } from "class-transformer";

export default class FileUploadResult {
  @Expose({ name: "total_count" }) totalCount?: number;
  @Expose({ name: "created_count" }) createdCount?: number;
  @Expose({ name: "updated_count" }) updatedCount?: number;
  @Expose({ name: "deleted_count" }) deletedCount?: number;
  @Expose({ name: "error" }) error?: string;
}
